import PropTypes from 'prop-types'
import { memo } from 'react'
import Icon from '../Icon/Icon'
import styles from './Note.module.scss'

/**
 * The `Note`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Note (props) {
  const { children, className, icon } = props

  return (
    <div className={`${styles.note} ${className}`.trimEnd()}>
      {icon && (
        <div className={styles.noteIcon}>
          <Icon icon={icon} />
        </div>
      )}
      <div className={styles.noteContent}>{children}</div>
    </div>
  )
}

/** @type {object} */
Note.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string
}

/** @type {object} */
Note.defaultProps = {
  children: null,
  className: '',
  icon: null
}

// Memoize
export default memo(Note)
